import React, { useCallback, useEffect, useState } from "react"
import { Redirect, Route } from 'react-router-dom'
import { get, set } from 'local-storage'
import { useGlobalState, useUserDispatcher } from '@hooks'
import { useAxios } from "../hooks/useAxios"


const UnAuthRoute: React.FC = (props) => {
  const globalState = useGlobalState()
  const { setTokenAuthData } = useUserDispatcher()
  const [isReady, setIsReady] = useState(false)
  const axios = useAxios()

  const fetchTokenAsync = useCallback(async (refreshToken: string) => {
    await axios.get(`auth/refreshToken`, {
      params: {
        refreshToken
      }
    })
      .then(response => {
        set<string>(`token`, response.data.token)
        set<string>(`refreshToken`, response.data.refreshToken)
        setTokenAuthData(response.data.token)
      })
  }, [])

  useEffect(() => {
    const refreshToken = get<string>('refreshToken')

    if (refreshToken) {
      fetchTokenAsync(refreshToken)
        .finally(() => {
          setIsReady(true)
        })
    } else {
      setIsReady(true)
    }
  }, [])

  if (isReady) {
    if (globalState.user.isAuthenticated) return <Redirect to="/" />

    return <Route {...props} />
  }

  return null
}


export default UnAuthRoute